

































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseFormulirCard from "@/BaseFormulirCard.vue";
import CommonSuket, { EnFormulirCategory } from "@/services/CommonFormulir";
import BaseFormulir from "@/BaseFormulir";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";

import pdf from "vue-pdf";
import moment from "moment";
import FormulirUjiFungsiKfr from "@/store/modules/FormulirUjiFungsiKfr";
import { storeSoap } from "./store/modules/soap";
import { storeKonsul } from "./store/modules/konsul";

@Component({
  components: {
    CardModalTtd,
    BaseFormulirCard,
    pdf
  }
})
export default class FormulirUjiFungsiKfrTabPage extends BaseFormulir {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  formSvc = new CommonSuket(EnFormulirCategory.UjiFungsiKfr);
  formStore = FormulirUjiFungsiKfr;

  get pdfUrl() {
    return this.dataForm
      ? this.getPdfUrl(EnFormulirCategory.UjiFungsiKfr, this.dataForm.id)
      : null;
  }

  get soap() {
    const soap = storeSoap.soapAll.filter(it => {
      return (
        it.unit?.id == userModule.user.unit_id &&
        it.user.id == userModule.user.id
      );
    });

    return soap.length ? soap[0] : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
    .toString()
    .concat(" Th");

  surat_date = moment().format("YYYY-MM-DD");
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  today = moment().format("YYYY-MM-DD");
  klinik = null;

  suratDateShow = false;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;
  loadedRatio = 0;

  tglPemeriksaan = moment().format("YYYY-MM-DD");
  tglPemeriksaanShow = false;
  diagMedis = null;
  diagFungsional = null;
  hasil = null;
  kesimpulan = null;
  rekomendasi = null;

  mounted() {
    this.changedataForm(this.dataForm);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        tgl_pemeriksaan: this.tglPemeriksaan,
        diag_medis: this.diagMedis,
        diag_fungsional: this.diagFungsional,
        hasil: this.hasil,
        kesimpulan: this.kesimpulan,
        rekomendasi: this.rekomendasi
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataForm
        ? this.formSvc.update(this.dataForm.id, this.input)
        : this.formSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          this.formStore.getByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  tglPemeriksaanFormat() {
    return this.tglPemeriksaan
      ? moment(this.tglPemeriksaan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  suratDateFormat() {
    return this.surat_date
      ? moment(this.surat_date, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataForm")
  changedataForm(val) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.nama = val.pasien.nama;
      this.umur = val.pasien.umur_th;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      this.diagMedis = val.content?.diag_medis;
      this.diagFungsional = val.content?.diag_fungsional;
      this.hasil = val.content?.hasil;
      this.kesimpulan = val.content?.kesimpulan;
      this.rekomendasi = val.content?.rekomendasi;
      this.tglPemeriksaan = val?.content?.tgl_pemeriksaan || this.today;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.surat_date = moment().format("YYYY-MM-DD");
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.diagMedis = null;
      this.diagFungsional = null;
      this.hasil = null;
      this.kesimpulan = null;
      this.rekomendasi = null;
      this.tglPemeriksaan = moment().format("YYYY-MM-DD");
    }
  }
}
